export default __webpack_public_path__ + "static/media/city-hall-email-negative.47f51f02.svg";